import { render, staticRenderFns } from "./VerifyUsernamePage.vue?vue&type=template&id=6f20a301"
import script from "./VerifyUsernamePage.vue?vue&type=script&lang=js"
export * from "./VerifyUsernamePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports